import css from "@styled-system/css";
import styled from "styled-components";
export * from "../../styles";
export var DropdownBody = styled.div(css({
    maxHeight: 400,
    overflow: "scroll"
}));
export var DropdownFooter = styled.div(css({
    display: "flex",
    justifyContent: "flex-end",
    minWidth: "max-content",
    paddingTop: "sm",
    paddingX: "md",
    whiteSpace: "nowrap"
}));

//# sourceMappingURL=styles.js.map